/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} These_Orange_Wallaby_AscendInputs */

const fr_these_orange_wallaby_ascend = /** @type {(inputs: These_Orange_Wallaby_AscendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clôturer`)
};

/**

* @param {These_Orange_Wallaby_AscendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const these_orange_wallaby_ascend = /** @type {((inputs?: These_Orange_Wallaby_AscendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<These_Orange_Wallaby_AscendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_these_orange_wallaby_ascend(inputs)
});